import React from 'react';
import {connect} from 'react-redux';
import {Menu} from 'semantic-ui-react';

const mapStateToProps = ({locales}) => ({
  locale: locales.locale,
});

const AppHeaderComponent = () => (
  <Menu position="right" inverted>
    <Menu.Item>
      <div className="ui companylogo" />
    </Menu.Item>
  </Menu>
);

const AppHeader = connect(mapStateToProps)(AppHeaderComponent);
export default AppHeader;
